import toastr from 'toastr';
import 'toastr/build/toastr.min.css'

toastr.options = {
  "closeButton": true,
  "debug": false,
  "newestOnTop": false,
  "progressBar": false,
  "positionClass": "toast-top-center",
  "preventDuplicates": false,
  "onclick": null,
  "showDuration": "300000",
  "hideDuration": "300000",
  "timeOut": "300000",
  "extendedTimeOut": "30000",
  "showEasing": "swing",
  "hideEasing": "linear",
  "showMethod": "fadeIn",
  "hideMethod": "fadeOut"
}

export function success_message(message) {
  toastr.success(message);
}

export function info_message(message) {
  toastr.info(message);
}

export function warning_message(message) {
  toastr.warning(message);
}

export function error_message(message, timeout = null) {
  if (timeout !== null) {
    toastr.error(message, '', { timeOut: timeout, extendedTimeOut: timeout });
  } else {
    toastr.error(message);
  }
}
